import React from 'react';
import { motion } from 'framer-motion';
import classNames from 'classnames';

interface StepIndicatorProps {
  steps: string[];
  currentStep: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ steps, currentStep }) => {
  return (
    <div className="flex items-center justify-between w-full max-w-2xl mx-auto mb-10 px-4">
      {steps.map((step, idx) => {
        const isCompleted = idx < currentStep;
        const isActive = idx === currentStep;
        
        return (
          <React.Fragment key={step}>
            <div className="flex flex-col items-center relative z-10">
              <motion.div
                initial={false}
                animate={{
                  backgroundColor: isActive || isCompleted ? '#f58d7f' : '#f1f5f9',
                  scale: isActive ? 1.2 : 1,
                  color: isActive || isCompleted ? '#ffffff' : '#94a3b8'
                }}
                className={classNames(
                  "w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm shadow-sm",
                  isActive ? "ring-4 ring-coral/20" : ""
                )}
              >
                {isCompleted ? '✓' : idx + 1}
              </motion.div>
              <span className={classNames(
                "text-[10px] sm:text-xs mt-2 font-bold transition-colors whitespace-nowrap",
                isActive ? "text-coral" : "text-slate-400"
              )}>
                {step}
              </span>
            </div>
            
            {idx < steps.length - 1 && (
              <div className="flex-1 h-[2px] bg-slate-100 mx-2 -mt-6 relative">
                <motion.div
                  initial={false}
                  animate={{ width: isCompleted ? '100%' : '0%' }}
                  className="absolute top-0 left-0 h-full bg-coral"
                  transition={{ duration: 0.5 }}
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepIndicator;
